<template>
  <div class="user-info__container">
    <span class="user-info">
      {{ user.name }}

      <span class="mx-2">|</span>

      {{ $t(user.tenantId) }}
    </span>

    <v-menu
      :nudge-bottom="10"
      offset-y origin="center center"
      transition="scale-transition"
      class="mr-2 prof-popup"
    >
      <template #activator="{on}">
        <v-btn
          :ripple="false"
          text
          color="#00072B"
          class="pl-1 pr-0 mr-0 user-popup-btn"
          v-on="on"
        >
          <v-avatar size="34px">
            <img v-if="avatar" :src="avatar" alt="name" />
            <img v-else-if="user.tenantId && user.tenantId.includes('lemeks')" src="/img/icons/lemeks-test-icon.png"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('salvest')" src="/img/icons/salvest-icon.png"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('estiko')" src="/img/icons/estiko-icon.png"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('demo2')" src="/img/icons/moodne-valgustus-icon.jpg"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('ekspressmeedia')" src="/img/icons/Delfi-yester.svg"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('trimtex')" src="/img/icons/trimtex_icon.svg"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('evocon')" src="/img/icons/evocon.png"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('salutaguse')" src="/img/icons/KOOS.svg"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('pipelife')" src="/img/icons/eesti-optik-logo.png"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('demo3')" src="/img/icons/tree-logo.png"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('demo4')" src="/img/icons/tree-logo.png"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('demo5')" src="/img/icons/tree-logo.png"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('georgfischer')" src="/img/icons/Georg_Fischer_logo.svg.png"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('cristella')" src="/img/icons/verston-logo.jpg"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('gospa')" src="/img/icons/gospa-logo.jfif"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('aripäev')" src="/img/icons/aripaev-logo.png"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('incap')" src="/img/icons/incap-logo.png"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('podiumnorth')" src="/img/icons/podiumnorth-square-logo.png"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('merit')" src="/img/icons/merit-logo.png"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('demo1')" src="/img/icons/elnet-logo.png"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('programmable-equity')" src="/img/icons/KOOS.svg"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('smart-accounts')" src="/img/icons/smart-accounts.png"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('trendsetter')" src="/img/icons/trendsetter.png"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('mercantile')" src="/img/icons/Mercantile-logo-200x58.png"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('weg')" src="/img/icons/WEG.jfif"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('linde-gas')" src="/img/icons/linde-logo.png"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('scandagra')" src="/img/icons/scandagra-logo.png"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('esteve')" src="/img/icons/esteve-logo.png"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('operail')" src="/img/icons/operail-logo.png"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId === 'er'" src="/img/icons/er-logo.png"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('ouman')" src="/img/icons/ouman-logo.png"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('puidukoda')" src="/img/icons/puidukoda-logo.png"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('maxima')" src="/img/icons/maxima-logo.png"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('rethinkers')" src="/img/icons/rethinkers-logo.png"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('topauto')" src="/img/icons/topauto-logo.png"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('projektiburoo')" src="/img/icons/projektiburoo-logo.png"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('dhlexpressestonia')" src="/img/icons/dhl-logo.png"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('beyond')" src="/img/icons/beyond-logo.png"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('hobbyhall')" src="/img/icons/phh-group-logo.png"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('plastone')" src="/img/icons/plastone-logo.png"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('stebby')" src="/img/icons/stebby-logo.jfif"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('kaup24')" src="/img/icons/kaup24-logo.png"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('tammer')" src="/img/icons/tammer-logo.svg"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('juunika')" src="/img/icons/juunika-logo.jfif"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('hydroscand')" src="/img/icons/hydroscand-logo.png"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('taavitarkvara')" src="/img/icons/taavi-logo.png"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('johvihaigla')" src="/img/icons/johvihaigla-logo.jpg"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('corrigo')" src="/img/icons/corrigo-logo.png"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('projekt363')" src="/img/icons/projekt363-logo.png"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('noto')" src="/img/icons/noto-logo.png"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('demo6')" src="/img/icons/demo6-logo.png"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('accelerando')" src="/img/icons/accelerando-logo.png"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('astlanda')" src="/img/icons/astlanda-logo.png"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('lightcodephotonics')" src="/img/icons/lightcodephotonics-logo.png"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('saint-gobain')" src="/img/icons/saintgobain-logo.png"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('torisawmill')" src="/img/icons/torisawmill-logo.png"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('navix')" src="/img/icons/navix-logo.png"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('treffex')" src="/img/icons/treffex-logo.jpg"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('autospirit')" src="/img/icons/autospirit-logo.png"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('svtrading')" src="/img/icons/svtrading-logo.svg"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('airestakstiaselts')" src="/img/icons/airest-logo.png"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('ascartartu')" src="/img/icons/ascartartu-logo.PNG"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('expressline')" src="/img/icons/expressline-logo.png"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('taavidemo')" src="/img/icons/taavidemo-logo.jpg"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('hotelltelegraaf')" src="/img/icons/hotelltelegraaf-logo.png"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('pharmapark')" src="/img/icons/pharmapark-logo.png"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('mehkaeesti')" src="/img/icons/mehka-logo.png"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('gscan')" src="/img/icons/gscan-logo.png"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('paljassaare')" src="/img/icons/paljassaare-logo.png"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('cleveron')" src="/img/icons/cleveron-logo.png"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('lindstrom')" src="/img/icons/lindstrom-logo.png"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('bauroc')" src="/img/icons/bauroc-logo.png"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('3stepit')" src="/img/icons/3stepit-logo.png"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('digitrukk')" src="/img/icons/digitrukk-logo.svg"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('tartuagro')" src="/img/icons/tartuagro-logo.png"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('klipmarine')" src="/img/icons/klipmarine-logo.png"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('raumedic')" src="/img/icons/raumedic-logo.jpg"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('tostamaa')" src="/img/icons/tostamaa-logo.png"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('terviseagentuur')" src="/img/icons/terviseagentuur-logo.png"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('wendre')" src="/img/icons/wendre-logo.jpg"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('fontes')" src="/img/icons/fontes-logo.png"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('figure')" src="/img/icons/fontes-logo.png"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('vbhestonia')" src="/img/icons/vbhestonia-logo.jpeg"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('estoniancell')" src="/img/icons/estoniancell-logo.png"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('basfuab')" src="/img/icons/basfuab-logo.png"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('estoniaou')" src="/img/icons/estoniaou-logo.png"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('werkukohvik')" src="/img/icons/werkukohvik-logo.jpg"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('arroagasild')" src="/img/icons/arroagasild-logo.png"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('fairownholding')" src="/img/icons/fairownholding-logo.png"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('mobiregroup')" src="/img/icons/mobire-logo.jpg"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('viciunaibaltic')" src="/img/icons/viciunaibaltic.png"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('puumarket')" src="/img/icons/puumarket.png"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('volvoestonia')" src="/img/icons/volvoestonia.png"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('bdoeesti')" src="/img/icons/bdoeesti.png"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('inseneriburootelora')" src="/img/icons/inseneriburootelora.png"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('afterone')" src="/img/icons/afterone.png"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('baltiautoosad')" src="/img/icons/baltiautoosad.png"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('starklogistics')" src="/img/icons/startlogistics.jpg"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('rapinapaberivabrik')" src="/img/icons/rappin.png"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('ignitiseesti')" src="/img/icons/ignitis-logo.png"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('ahhaateaduskeskus')" src="/img/icons/ahhaateaduskeskus-logo.png"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('efta')" src="/img/icons/efta-logo.png"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('vikinglineeesti')" src="/img/icons/vikingline-logo.png"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('kone')" src="/img/icons/kone-logo.png"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('alaskuul')" src="/img/icons/alaskuul-logo.jpg"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('zetesestonia')" src="/img/icons/zetes-logo.jpg"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('optimeraestonia')" src="/img/icons/optimeraestonia-logo.png"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('saueproduction')" src="/img/icons/solina-logo.png"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('scametsadeesti')" src="/img/icons/scametsadeesti-logo.png"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('afg')" src="/img/icons/afg-logo.png"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('krattworks')" src="/img/icons/krattworks-logo.png"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('addinol')" src="/img/icons/addinol-logo.png"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('scamezslatvija')" src="/img/icons/scamezslatvija-logo.png"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('stadaestonia')" src="/img/icons/stadaestonia-logo.png"
                 alt="name"
            >
            <img v-else-if="user.tenantId && user.tenantId.includes('viimsihaldus')" src="/img/icons/viimsihaldus-logo.png"
                 alt="name"
            >
            <v-icon v-else x-large>
              mdi-account
            </v-icon>
          </v-avatar>

          <v-icon small color="#B0BAC9">
            mdi-chevron-down
          </v-icon>
        </v-btn>
      </template>

      <v-list class="py-2 px-5" max-width="287" min-width="287">
        <v-list>
          <p class="text-center mb-0">
            {{ $t(user.tenantId) }}
          </p>
        </v-list>
      </v-list>
    </v-menu>

    <v-menu
      :nudge-bottom="10"
      offset-y
      origin="center center"
      transition="scale-transition"
      class="mr-2 prof-popup"
      z-index="60"
    >
      <template #activator="{on}">
        <v-btn :ripple="false" icon small class="pl-0 user-popup-btn" v-on="on">
          <v-icon small color="#B0BAC9">
            mdi-dots-vertical
          </v-icon>
        </v-btn>
      </template>

      <v-list class="pt-0 px-5 pb-3" max-width="287" min-width="287">
        <v-list>
          <v-list-item class="pl-0">
            <v-list-item-avatar v-if="avatar" class="mr-0">
              <img v-if="avatar" :src="avatar" alt="name" />
            </v-list-item-avatar>

            <UserIcon class="pl-1 mr-2" />

            <v-list-item-content>
              <v-list-item-title class="black--text">
                {{ name }} ({{ user.id }})
              </v-list-item-title>
              <v-list-item-subtitle class="gray-text">
                {{ user.email }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>

        <v-divider />

        <v-list-item
          v-for="(item, index) in menuitems"
          :key="index"
          :to="!item.href ? {name: item.name} : null"
          :href="item.href"
          :disabled="item.disabled"
          :target="item.target"
          ripple="ripple"
          rel="noopener"
          class="pl-0"
          @click="item.click"
        >
          <v-list-item-action v-if="item.icon" class="mr-1 px-0">
            <UserIcon v-if="index === 0" class="pl-1 mr-2" />
            <v-icon v-else :class="{'rotate-icon': item.icon === 'mdi-call-missed'}" color="#B0BAC9" size="18">
              {{ item.icon }}
            </v-icon>
          </v-list-item-action>

          <v-list-item-content class="ml-0">
            <v-list-item-title class="black--text">
              {{ $t(item.title) }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>

    <v-dialog v-model="profileDialog" max-width="655px" content-class="modal-form-wrapper">
      <user-profile :dialog-opened="profileDialog" @close="closeDialog" />
    </v-dialog>

    <v-dialog v-model="passwordDialog" max-width="655px" content-class="modal-form-wrapper">
      <password-dialog :dialog-opened="passwordDialog" @close="closeDialog" />
    </v-dialog>
  </div>
</template>

<script>

// libs.
import { mapGetters } from 'vuex';

// components.
import UserIcon from '@/assets/icons/UserIcon.vue';
import UserProfile from './AppUserProfile.vue';
import PasswordDialog from './AppUserPassword.vue';

export default {
  name: 'AppProfile',
  components: { UserProfile, PasswordDialog, UserIcon },
  data() {
    return {
      profileDialog: false,
      passwordDialog: false,
      menuitems: [
        {
          icon: 'mdi-account-outline',
          href: '#',
          title: 'toolbar.profile',
          click: () => {
            this.profileDialog = true;
          },
        },
        {
          icon: 'mdi-lock',
          href: '#',
          title: 'toolbar.changePassword',
          click: () => {
            this.passwordDialog = true;
          },
        },
        {
          icon: 'mdi-call-missed',
          href: '#',
          title: 'toolbar.logout',
          click: () => {
            this.logout();
          },
        },
      ],
    };
  },
  computed: {
    ...mapGetters(['user', 'name', 'avatar', 'status']),
  },
  methods: {
    closeDialog() {
      this.profileDialog = false;
      this.passwordDialog = false;
    },

    logout() {
      this.$store.dispatch('LogOut');
    },
  },
};
</script>

<style lang="scss" scoped>

.user-info__container {
  display: flex;
  align-items: center;
}
.user-info {
  color: $yester-dark;
  font-size: 16px;
  text-wrap: nowrap;
}
.rotate-icon {
  transform: scaleX(-1);
  -moz-transform: scaleX(-1);
  -webkit-transform: scaleX(-1);
  -ms-transform: scaleX(-1);
}
.user-popup-btn {
  background-color: transparent !important;
  padding-right: 0 !important;
  padding-left: 0 !important;
  & .v-icon {
    margin: 0 !important;
    padding: 0 !important;
  }
  &::before {
    background-color: transparent !important;
  }
}
.gray-text {
  color: #B0BAC9 !important;
}
.prof-popup {
  position: fixed;
  top: 20px;
  z-index: 30 !important;
}

</style>
